import { Link } from "react-router-dom";

export default function WhatIsSection() {
  return (
    <section id="what-is" className="py-16 md:py-24 bg-background-50">
      <div className="w-full px-4 md:px-6 lg:px-8">
        <div className="max-w-6xl mx-auto">
          <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
            {/* Left: Text Content */}
            <div className="flex-1 text-left">
              <span className="inline-block text-xs font-medium text-accent-600 bg-accent-100 px-3 py-1 rounded-full mb-4 tracking-wide">
                ABOUT VIGORBUY
              </span>
              <h2 className="text-2xl md:text-4xl lg:text-5xl font-heading font-bold text-foreground-950 leading-tight mb-6">
                What Is Vigorbuy{" "}
                <span className="text-accent-600">Spreadsheet</span>?
              </h2>
              <div className="space-y-4 text-sm md:text-base text-foreground-600 leading-relaxed max-w-xl">
                <p>
                  Vigorbuy Spreadsheet is an organized resource that helps users
                  explore categories, compare information, and discover useful
                  product references efficiently. Unlike traditional searching
                  methods that scatter results across multiple pages, the
                  spreadsheet structure allows you to navigate fashion
                  categories quickly and access everything in one centralized
                  location.
                </p>
                <p>
                  Think of it as a curated directory for fashion enthusiasts —
                  whether you are hunting for the perfect pair of sneakers,
                  browsing seasonal jacket collections, or comparing accessory
                  options, the Vigorbuy Spreadsheet layouts everything in a
                  clean, scannable format that eliminates the guesswork from
                  online shopping research.
                </p>
                <p>
                  Since its inception, thousands of savvy shoppers have turned
                  to Vigorbuy Spreadsheet as their go-to reference for organized
                  product discovery. The resource is continuously updated to
                  reflect the latest category structures and trending items,
                  ensuring you always have access to current, relevant
                  information.
                </p>
              </div>
              <div className="flex items-center gap-4 mt-8">
                <Link
                  to="/vigorbuy-spreadsheet-guide"
                  className="inline-flex items-center gap-2 px-6 py-3 bg-accent-500 text-background-50 text-sm font-semibold rounded-full hover:bg-accent-600 transition-all duration-200 whitespace-nowrap cursor-pointer"
                >
                  Read Full Guide
                  <i className="ri-arrow-right-line text-sm"></i>
                </Link>
                <a
                  href="#benefits"
                  className="inline-flex items-center gap-2 text-sm font-medium text-foreground-600 hover:text-foreground-950 transition-colors duration-200 whitespace-nowrap"
                >
                  View Benefits
                  <i className="ri-arrow-down-line text-sm"></i>
                </a>
              </div>
            </div>

            {/* Right: Image Card */}
            <div className="flex-1 w-full">
              <div className="relative rounded-2xl overflow-hidden aspect-[4/5] max-w-md mx-auto lg:max-w-none">
                <img
                  src="https://readdy.ai/api/search-image?query=Clean%20organized%20fashion%20curation%20workspace%20with%20light%20cream%20desktop%20surface%2C%20modern%20laptop%20displaying%20aesthetic%20product%20grid%20layout%2C%20sage%20green%20notebook%20and%20ceramic%20vase%20with%20dried%20flowers%2C%20soft%20diffused%20window%20light%20creating%20calm%20atmosphere%2C%20minimalist%20editorial%20workspace%20photography%2C%20sophisticated%20neutral%20color%20palette%2C%20Western%20contemporary%20creative%20studio%20aesthetic%2C%20warm%20inviting%20ambiance%2C%20sharp%20focus%20on%20organized%20display%20screen%2C%20refined%20professional%20environment&width=800&height=1000&seq=whatis-vb-v2-2026z&orientation=portrait"
                  alt="Vigorbuy Spreadsheet organized fashion product discovery resource"
                  title="What Is Vigorbuy Spreadsheet - Product Discovery"
                  className="w-full h-full object-cover object-top"
                />
                <div className="absolute top-4 left-4">
                  <span className="inline-block px-4 py-1.5 rounded-full bg-white/90 backdrop-blur-sm text-xs font-medium text-foreground-800">
                    Organized Discovery
                  </span>
                </div>
                <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/60 via-black/30 to-transparent p-6">
                  <p className="text-white text-sm font-medium">
                    All your fashion categories in one place
                  </p>
                  <p className="text-white/70 text-xs mt-1">
                    Efficient. Organized. Always updated.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}